import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },
  icons: {
    iconfont: 'mdi',
    values: {},
  },
  rtl: false,
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: undefined,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: {
      light: {
        primary: colors.blue.darken3,
        secondary: colors.grey,
        accent: colors.blue.darken3,
        error: colors.red.darken1,
        info: colors.blue,
        success: colors.green,
        warning: colors.orange,
        create: colors.green.darken1,
        save: colors.blue.darken3,
        delete: colors.red.darken1
      },
      dark: {
        primary: colors.blue.darken3,
        secondary: colors.grey,
        accent: colors.pink,
        error: colors.red,
        info: colors.blue,
        success: colors.green,
        warning: colors.orange,
        create: colors.green,
        save: colors.blue.darken3,
        delete: colors.red.darken1
      },
    },
  },
});
